import { render, staticRenderFns } from "./CreateRequest.vue?vue&type=template&id=4e55e0eb&scoped=true"
import script from "./CreateRequest.vue?vue&type=script&lang=js"
export * from "./CreateRequest.vue?vue&type=script&lang=js"
import style0 from "./CreateRequest.vue?vue&type=style&index=0&id=4e55e0eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e55e0eb",
  null
  
)

export default component.exports